module.exports = __webpack_public_path__ + "img/svit-mov.b589d393.png";